import { TwoFactorSetupTotpStepRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/2fa_setup/new_totp')({
  component: TwoFactorSetupTotpStepRoute,
});
